import { useMemo } from "react";

export const useMinMultiInputWidth = (strings: string[]) => {
  return useMemo(() => {
    return strings.map((s) => s.length * 8 + 16);
  }, [strings]);
};
